import {ActionType} from "@src/store/ActionType";

export const GET_DIPLOMAS = new ActionType("GET_DIPLOMAS");
export const GET_CHECK_IIN = new ActionType("GET_CHECK_IIN");
export const GET_SEARCH = new ActionType("GET_SEARCH");
export const CANCEL_FILTER = new ActionType("CANCEL_FILTER");
export const GET_GRADUATE_DETAILS = new ActionType("GRADUATE_DETAILS");
export const POST_TOOGLE_FAVORITE_DIPLOMAS = new ActionType("POST_TOOGLE_FAVORITE_DIPLOMAS");
export const GET_FAVORITE_DIPLOMAS = new ActionType("GET_FAVORITE_DIPLOMAS");
export const GET_DIPLOMA_TRANSCRIPT = new ActionType("GET_DIPLOMA_TRANSCRIPT");